// import TableHead from "./Table/TableHead";

// import useTable from "./Provider/useTable";
// import TableRow from "./Table/TableRow";

// import { Table, TBody } from "../components";

// import { useNavigate } from "react-router-dom";
// import TableContext from "./Provider/TableContext";
// import ApproveModal from "./Table/ApproveModal";
// import CancelModal from "./Table/CancelModal";

// function Requests() {
//   const {
//     limit,
//     setLimit,
//     docs,
//     setDocs,
//     isLoading,
//     setIsLoading,
//     isFiltered,
//     setIsFiltered,
//     pagination,
//     genders,
//     dobRange,
//     setDobRange,
//     selectedGenders,
//     setSelectedGenders,
//     doaRange,
//     setDoaRange,
//     setOrder,
//     clearFilters,
//     requestId,
//     setRequestId,
//     refetchDocs,
//     showApproveModal,
//     setShowApproveModal,
//     handleApprove,
//     showCancelModal,
//     setShowCancelModal,
//     handleCancel,
//   } = useTable();

//   const navigate = useNavigate();

//   return (
//     <>
//       <TableContext.Provider
//         value={{
//           limit,
//           setLimit,
//           docs,
//           setDocs,
//           isLoading,
//           setIsLoading,
//           isFiltered,
//           setIsFiltered,
//           pagination,
//           genders,
//           dobRange,
//           setDobRange,
//           selectedGenders,
//           setSelectedGenders,
//           doaRange,
//           setDoaRange,
//           setOrder,
//           clearFilters,
//           requestId,
//           setRequestId,
//           refetchDocs,
//           showApproveModal,
//           setShowApproveModal,
//           handleApprove,
//           showCancelModal,
//           setShowCancelModal,
//           handleCancel,
//         }}
//       >
//         <Table
//           label="All Requests"
//           isLoading={isLoading}
//           setIsLoading={setIsLoading}
//           setDocs={setDocs}
//           isFiltered={isFiltered}
//           handleAdd={() => navigate("add")}
//           setIsFiltered={setIsFiltered}
//           handleRemoveFilters={clearFilters}
//           pagination={pagination}
//           url="roles/search"
//         >
//           <TableHead setOrder={setOrder} />
//           <TBody>
//             {docs.map((doc, i) => {
//               return <TableRow key={doc?.id || i} doc={doc} />;
//             })}
//           </TBody>
//         </Table>
//       </TableContext.Provider>
//       {showApproveModal && (
//         <ApproveModal
//           showApproveModal={showApproveModal}
//           setShowApproveModal={setShowApproveModal}
//           handleApprove={handleApprove}
//         />
//       )}
//       {showCancelModal && (
//         <CancelModal
//           showCancelModal={showCancelModal}
//           setShowCancelModal={setShowCancelModal}
//           handleCancel={handleCancel}
//         />
//       )}
//     </>
//   );
// }

// export default Requests;

import TableHead from "./Table/TableHead";
import useTable from "./Provider/useTable";
import TableRow from "./Table/TableRow";
import { Table, TBody } from "../components";

import { useNavigate } from "react-router-dom";
import TableContext from "./Provider/TableContext";
import ApproveModal from "./Table/ApproveModal";
import CancelModal from "./Table/CancelModal";

function Requests() {
  const {
    limit,
    setLimit,
    docs,
    setDocs,
    isLoading,
    setIsLoading,
    isFiltered,
    setIsFiltered,
    pagination,
    genders,
    dobRange,
    setDobRange,
    selectedGenders,
    setSelectedGenders,
    doaRange,
    setDoaRange,
    setOrder,
    clearFilters,
    requestId,
    setRequestId,
    refetchDocs,
    showApproveModal,
    setShowApproveModal,
    handleApprove,
    showCancelModal,
    setShowCancelModal,
    handleCancel,
  } = useTable();

  const navigate = useNavigate();

  return (
    <>
      <TableContext.Provider
        value={{
          limit,
          setLimit,
          docs,
          setDocs,
          isLoading,
          setIsLoading,
          isFiltered,
          setIsFiltered,
          pagination,
          genders,
          dobRange,
          setDobRange,
          selectedGenders,
          setSelectedGenders,
          doaRange,
          setDoaRange,
          setOrder,
          clearFilters,
          requestId,
          setRequestId,
          refetchDocs,
          showApproveModal,
          setShowApproveModal,
          handleApprove,
          showCancelModal,
          setShowCancelModal,
          handleCancel,
        }}
      >
        <Table
          label="All Requests"
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setDocs={setDocs}
          isFiltered={isFiltered}
          handleAdd={() => navigate("add")}
          setIsFiltered={setIsFiltered}
          handleRemoveFilters={clearFilters}
          pagination={pagination}
          url="roles/search"
        >
          <TableHead setOrder={setOrder} />
          <TBody>
            {docs.map((doc, i) => {
              return <TableRow key={doc?.id || i} doc={doc} />;
            })}
          </TBody>
        </Table>
      </TableContext.Provider>

      {/*Pass requestId as selectedRequestId to ApproveModal */}
      {showApproveModal && (
        <ApproveModal
          showApproveModal={showApproveModal}
          setShowApproveModal={setShowApproveModal}
          handleApprove={handleApprove}
          selectedRequestId={requestId}
          fetchRequests={refetchDocs}
        />
      )}

      {showCancelModal && (
        <CancelModal
          showCancelModal={showCancelModal}
          setShowCancelModal={setShowCancelModal}
          handleCancel={handleCancel}
          selectedRequestId={requestId}
          fetchRequests={refetchDocs}
        />
      )}
    </>
  );
}

export default Requests;
